var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "position-info",
      class: [{ invisible: _vm.$store.state.positionIndex <= 0 }]
    },
    [
      _c(
        "a",
        {
          staticClass: "action show-fen",
          attrs: { href: "javascript:" },
          on: { click: _vm.toggleFen }
        },
        [
          _c("div", { staticClass: "name" }, [
            _vm._v(_vm._s(_vm.showingFen ? "Hide" : "Show") + " FEN")
          ])
        ]
      ),
      _c("div", { staticClass: "position-description" }, [
        _vm.showingFen
          ? _c("div", { staticClass: "fen" }, [
              _vm._v(_vm._s(_vm.$store.getters.currentFen))
            ])
          : _vm._e(),
        !_vm.showingFen
          ? _c("div", [_vm._v(_vm._s(_vm.$store.getters.positionInfoText))])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0a914be", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0a914be","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/position_info.vue
// module id = 243
// module chunks = 0